/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-30 17:02:02
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-19 15:37:10
 */
const goods = [
    {
      path: '/goods/goodsDetail/:type/:id',
      name: 'educationDetail',
      component: () => import('../views/goods/goodsDetail.vue'),
    },
    {
      path: '/refund/detail/:type/:id',
      name: 'refundDetail',
      component: () => import('../views/refund/detail.vue'),
    },
  ]
  export default goods


// WEBPACK FOOTER //
// ./src/router/goods.js